export default __webpack_public_path__ + "static/media/Armbands of the Renegade.4235e3c3.jpg";